import * as ACTIONS from '@/store/constants/actions.js';
import * as GETTERS from '@/store/constants/getters.js';
import * as MUTATIONS from '@/store/constants/mutations.js';
import {
    fetchFollowers,
    fetchFollowing,
    fetchMultipleUsers,
} from '../../../resources/user';
import { parseV2 } from '@/store/users.js';

export const actions = {
    /*
     * CM-172: Used for remainder of PHP user data until Tyrion is complete.
     * TODO: refactor for Tyrion when ready.
     */
    [ACTIONS.FETCH_REMAINDER_USER_INFO](
        { getters, commit },
        { usersData, site_uuid },
    ) {
        const { name: domain } = getters[GETTERS.SITE_BY_UUID](site_uuid);
        const users = [];

        usersData.forEach(({ user_uuid }) => {
            if (!getters[GETTERS.USER_BY_UUID](user_uuid)) {
                users.push(user_uuid);
                commit(MUTATIONS.SET_USER, { uuid: user_uuid });
            }
        });

        if (users.length === 0) {
            return {};
        }

        return fetchMultipleUsers(users, domain, site_uuid)
            .then(({ responses }) => {
                const userNames = {};
                for (const user_uuid in responses) {
                    const { name, pic_small } = responses[user_uuid].result;
                    userNames[user_uuid] = {
                        name,
                        pic_small,
                    };
                }

                return userNames;
            })
            .catch((reject) => {
                // eslint-disable-next-line no-console
                console.warn('Failed to fetch user info', reject);
            });
    },

    [ACTIONS.FETCH_FOLLOWING_DATA](
        { getters, commit, dispatch },
        { user_uuid, site_uuid },
    ) {
        const followData = getters[GETTERS.FOLLOW_DATA_BY_UUID](user_uuid);
        if (followData) {
            return Promise.resolve(followData);
        }

        let followers,
            followersCount,
            following,
            followingCount,
            users;

        return Promise.all([
            fetchFollowers(user_uuid, site_uuid),
            fetchFollowing(user_uuid, site_uuid),
        ]).then((response) => {
            followers = response[0].subscriptions.map(parseV2);
            following = response[1].subscriptions.map(parseV2);
            followersCount = response[0].total;
            followingCount = response[1].total;
            users = followers.concat(following);
            return users;
        }).then((users_response) => dispatch(
            ACTIONS.FETCH_REMAINDER_USER_INFO, {
                usersData: users_response,
                site_uuid,
            },
        )).then((usersExtra) => {
            users.forEach((user) => {
                user = {
                    ...user,
                    ...usersExtra[user.user_uuid],
                };

                commit(MUTATIONS.SET_USER, {
                    uuid: user.user_uuid,
                    user,
                });
            });

            commit(MUTATIONS.UPDATE_FOLLOWS, {
                user_uuid,
                followers: followers.map((user) => ({
                    uuid: user.user_uuid,
                    date_followed: user.date_created,
                })),
                followersCount,
                following: following.map((user) => ({
                    uuid: user.user_uuid,
                    date_followed: user.date_created,
                })),
                followingCount,
            });
        });
    },
};
